import { Anvil } from "lucide-react";
import { Suspense } from "react";
import { Outlet } from "react-router";

const STRATA = [
	{ width: "100%", opacity: 0.26 },
	{ width: "78%", opacity: 0.18 },
	{ width: "55%", opacity: 0.11 },
	{ width: "34%", opacity: 0.06 },
];

export function AuthLayout() {
	return (
		<div className="grid min-h-screen bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
			{/* ─── Furnace door ─────────────────────────────────────────── */}
			<div className="relative hidden overflow-hidden border-r border-sidebar-border bg-sidebar lg:flex lg:flex-col">
				{/* heat strata rising from the floor */}
				<div
					aria-hidden
					className="pointer-events-none absolute inset-x-0 bottom-0 flex flex-col-reverse items-start gap-[3px]"
				>
					{STRATA.map((band) => (
						<div
							key={band.width}
							className="h-10 bg-gradient-to-r from-primary via-chart-2 to-transparent"
							style={{ width: band.width, opacity: band.opacity }}
						/>
					))}
				</div>

				<div className="relative flex items-center gap-2.5 px-10 pt-9">
					<div className="flex size-8 items-center justify-center rounded-sm bg-primary shadow-[inset_0_1px_0_0_oklch(1_0_0/0.2),inset_0_-2px_0_0_oklch(0_0_0/0.25)]">
						<Anvil className="size-4.5 text-primary-foreground" strokeWidth={2.25} />
					</div>
					<p className="font-display font-wide text-[15px] font-extrabold uppercase tracking-[0.06em] text-sidebar-accent-foreground">
						Forgedock
					</p>
				</div>

				<div className="relative flex flex-1 flex-col justify-end px-10 pb-14">
					<p className="label-micro text-primary">Agent operations console</p>
					<p
						aria-hidden
						className="font-display mt-6 space-y-1 text-[4.6rem] font-extrabold uppercase leading-[0.92] tracking-tight"
					>
						<span className="font-wide block text-sidebar-accent-foreground">Forge.</span>
						<span
							className="font-wide block"
							style={{
								WebkitTextStroke: "1.5px oklch(0.76 0.016 75 / 0.45)",
								color: "transparent",
							}}
						>
							Dock.
						</span>
						<span className="font-wide block text-sidebar-accent-foreground">Deploy.</span>
					</p>
					<p className="mt-6 max-w-sm text-sm leading-relaxed text-sidebar-foreground/75">
						Profiles, connections, keys, and conversations: every agent in your fleet, shaped and
						shipped from one floor.
					</p>
					<div className="heat-rule mt-8 w-40" />
					<p className="label-micro mt-4 text-[10px] text-sidebar-muted">
						Forge Labs · Console FD-01
					</p>
				</div>
			</div>

			{/* ─── Workbench ──────────────────────────────────────────── */}
			<div className="flex min-h-screen items-center justify-center px-5 py-10">
				<div className="w-full max-w-sm animate-forge-rise">
					<div className="mb-8 flex items-center gap-2.5 lg:hidden">
						<div className="flex size-8 items-center justify-center rounded-sm bg-primary">
							<Anvil className="size-4.5 text-primary-foreground" strokeWidth={2.25} />
						</div>
						<p className="font-display font-wide text-[15px] font-extrabold uppercase tracking-[0.06em]">
							Forgedock
						</p>
					</div>
					<Suspense fallback={null}>
						<Outlet />
					</Suspense>
				</div>
			</div>
		</div>
	);
}

export function AuthFormHeader({ title, blurb }: { title: string; blurb: string }) {
	return (
		<div className="space-y-2">
			<p className="label-micro text-primary">Access</p>
			<h2 className="font-display font-wide text-2xl font-extrabold uppercase leading-none tracking-tight">
				{title}
			</h2>
			<p className="text-sm leading-relaxed text-muted-foreground">{blurb}</p>
		</div>
	);
}
